import { Component, OnInit, Host, Input } from '@angular/core';
import { Project } from 'src/DataModels';
import { AppUtilityService } from 'src/app/app-utility.service';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-worksheet-brokerage-details-module',
  templateUrl: './worksheet-brokerage-details-module.component.html',
  styleUrls: ['./worksheet-brokerage-details-module.component.css']
})
export class WorksheetBrokerageDetailsModuleComponent implements OnInit 
{
  private _isInExportMode: boolean = false;

  @Input()
  set IsInExportMode(isInExportMode: boolean)
  {
    this._isInExportMode = isInExportMode;
  }

  get IsInExportMode()
  {
    return this._isInExportMode;
  }

  private _selectedProject: Project = null;
  
  @Input()
  set SelectedProject(project: Project)
  {
    this._selectedProject = project;
  }

  get SelectedProject()
  {
    return this._selectedProject;
  }

  public nameField: FormControl = new FormControl();
  public addressField: FormControl = new FormControl();
  public cityField: FormControl = new FormControl();
  public provinceField: FormControl = new FormControl();
  public postalCodeField: FormControl = new FormControl();

  constructor(public appUtilityService: AppUtilityService) { }

  ngOnInit() 
  {
  }
}
